import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SeamLockableRepositoryService extends BaseRepositoryService<
  ModelRegistry['seam-lockable']
> {
  recordName = 'seam-lockable';
  implementMethods = ['unloadAll', 'createRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/seam-lockable': SeamLockableRepositoryService;
  }
}
